/* @flow */
import * as React from 'react';
import PeopleListTableDataContainer from './PeopleListTableDataContainer.jsx';

type Props = {
  entityType: string,
  entityUuid: string,
};

export default class PeopleListTable extends React.Component<Props> {
  render() {
    return (
      <div>
        {/* Table options will go here */}
        <PeopleListTableDataContainer
          entityType={this.props.entityType}
          entityUuid={this.props.entityUuid}
          grade={null}
          query=""
          roles={['teacher', 'student', 'admin', 'unknown']}
          rostered="all"
        />
      </div>
    );
  }
}
